export default __webpack_public_path__ + "static/media/051-wind sign.b1957728.svg";